<template>

  <b-container fluid class="suggestion-section">

    <b-col class="h-100 pt-5">

      <b-row class="text-center">
        <h1>We'd love your feedback!</h1>
        <p class="mt-5">Have a feature request? Find an issue? Want your YouTube channel included? Send us a message below and we'll consider your request as soon as possible.</p>
      </b-row>

      <b-row>
        <div id="my-reform"></div>
      </b-row>

    </b-col>
  </b-container>

</template>

<script>

export default {
  name: "Home",

  mounted() {
    window.Reform('init', {
      url: 'https://forms.reform.app/dMuHah/suggestion-box/6HVzfC',
      target: '#my-reform',
      background: 'transparent',
    })
  },
};

</script>

<style>
.suggestion-section {
  background: rgb(10, 10, 10);
  color: white;
  margin-top: 66px;
  min-height: calc(100vh - 134px);
}

.suggestion-section p {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
